export default __webpack_public_path__ + "static/media/mac.72603ede.png";